import { type SVGProps, useId } from 'react';

export const Coingecko2 = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg viewBox="0 0 14 16" {...props}>
      <g clipPath={`url(#${id})`}>
        <path
          d="M13.9998 7.96393C14.0172 12.3823 10.8973 15.9799 7.03172 15.9999C3.16562 16.0199 0.0175742 12.4544 7.32683e-05 8.03608C-0.0174276 3.61775 3.1025 0.0200793 6.96861 7.87604e-05C10.8342 -0.0193157 13.9822 3.54563 13.9998 7.96393Z"
          fill="#FFE866"
        />
        <path
          d="M10.5507 5.13629C10.0427 4.96845 9.51657 4.7297 8.98305 4.48913C8.95229 4.33646 8.83405 4.14617 8.59433 3.91291C8.2459 3.56751 7.59148 3.5766 7.02615 3.7293C6.40193 3.56146 5.78518 3.50145 5.19332 3.66384C0.353519 5.1878 3.09746 8.904 1.32031 12.6408C1.57328 13.2535 4.36332 16.1967 8.24219 15.8699C8.24219 15.8699 6.89356 12.167 9.93712 10.3892C12.4058 8.94764 14.1893 6.27062 10.5502 5.13567L10.5507 5.13629Z"
          fill="#4BCC00"
        />
        <path
          d="M7.36079 6.02719C7.36079 6.88157 6.75469 7.57356 6.00754 7.57356C5.26039 7.57356 4.6543 6.88157 4.6543 6.02719C4.6543 5.17281 5.26039 4.48145 6.00754 4.48145C6.75469 4.48145 7.36079 5.17341 7.36079 6.02719Z"
          fill="white"
        />
        <path
          d="M12.2439 8.25275C11.1477 9.1356 9.89982 9.80514 8.13119 9.80514C7.30334 9.80514 7.13522 8.79991 6.58791 9.29253C6.30524 9.54702 5.3093 10.116 4.51857 10.073C3.72095 10.0293 2.44763 9.49978 2.08965 7.57227C1.94806 9.49978 1.87593 10.9201 1.24219 12.5476C2.79788 15.1414 5.51037 16.4318 8.2415 15.8706C7.94823 13.5299 9.73861 11.2376 10.7473 10.0645C11.1291 9.62034 11.861 8.89503 12.2439 8.25275Z"
          fill="#4BCC00"
        />
        <path
          d="M6.5773 7.27759C7.01586 7.27759 7.37139 6.71286 7.37139 6.01623C7.37139 5.31961 7.01586 4.75488 6.5773 4.75488C6.13873 4.75488 5.7832 5.31961 5.7832 6.01623C5.7832 6.71286 6.13873 7.27759 6.5773 7.27759Z"
          fill="#0D1217"
        />
        <path
          d="M6.89453 3.72621C7.32777 3.92271 8.90991 4.52059 9.59444 4.75527C8.89554 3.4395 7.83636 3.51543 6.89453 3.72621Z"
          fill="#35AF00"
        />
        <path d="M6.57771 6.01667L5.625 5.2959V6.73744L6.57771 6.01667Z" fill="white" />
      </g>
      <defs>
        <clipPath id={`url(#${id})`}>
          <rect width="13.9998" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
